module.exports = __webpack_public_path__ + "img/belgium-flag.f1ddab30.png";